"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getFallbackValueIfNull(value, fallback) {
    return value === null ? fallback : value;
}
exports.default = getFallbackValueIfNull;
//# sourceMappingURL=getFallbackValueIfNull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/utils/getFallbackValueIfNull.js
// module id = 1830
// module chunks = 2 39 105 108